import React, { useEffect, useState } from "react";
import { staffMembers, thisAcademicYear } from "../utils/utils.statiquedata";
import { PageSectionHeader } from "./subcomponents/PageSectionHeader";
import { ProfileCard } from "./subcomponents/ProfileCard";
import { apiGet } from "../utils/api";

export const Organizer: React.FC = () => {
  const [allMembers, setAllMembers] = useState<StaffMember[]>(staffMembers);

  useEffect(() => {
    let active = true;
    apiGet("/staff")
      .then((d) => {
        if (active && Array.isArray(d?.rows) && d.rows.length) setAllMembers(d.rows);
      })
      .catch(() => { /* keep static fallback */ });
    return () => { active = false; };
  }, []);

  const members: StaffMember[] = allMembers.filter((member) => member.isOrganizer).sort((a, b) => a.id - b.id);

  return (
    <section className="about-governance" aria-labelledby="about-governance-heading">
      <PageSectionHeader
        id="about-governance-heading"
        eyebrow="Direction"
        title={`Gouvernance et comité de gestion ${thisAcademicYear}`}
        lead={
          <>
            L&apos;Université Libre des Pays des Grands Lacs est régie par un conseil
            d&apos;administration, un conseil de l&apos;université, un conseil scientifique et un
            comité de gestion piloté par un Recteur. L&apos;établissement est organisé autour de
            sept facultés et de services dédiés à la vie universitaire.
          </>
        }
        align="center"
      />

      <ul className="about-governance__grid">
        {members.map((member) => (
          <li key={member.uuid}>
            <ProfileCard profile={member} showDescription variant="team" />
          </li>
        ))}
      </ul>
    </section>
  );
};
